import { useState, useEffect } from "react";
import { api, type ItemizationRequest } from "../api/client";
import { Icon } from "./Icons";
import ItemizationForm from "./ItemizationForm";

interface ItemizationWithDetails extends ItemizationRequest {
  merchant: string | null;
  amount: number;
}

export default function ItemizationBanner() {
  const [items, setItems] = useState<ItemizationWithDetails[]>([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get<{ data: ItemizationWithDetails[] }>("/api/v1/nutrition/pending-itemizations");
      setItems(res.data || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  if (loading || items.length === 0) return null;

  return (
    <div className="xpn-card" style={{ border: "1px solid var(--xpn-color-warning)", padding: 16, marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <Icon name="warning" />
        <span className="xpn-text-body-md xpn-text" style={{ fontWeight: 650 }}>
          {items.length} transaction{items.length > 1 ? "s" : ""} need itemization
        </span>
      </div>

      {items.map((item) => (
        <div key={item.id}>
          <div
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", padding: "8px 0" }}
            onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}
          >
            <div>
              <div className="xpn-text-body-md xpn-text">{item.merchant || "Unknown merchant"}</div>
              <div className="xpn-text-caption xpn-text-muted">₹{item.amount} — {item.request_reason.replace("_", " ")}</div>
            </div>
            <Icon name="chevronDown" />
          </div>
          {expandedId === item.id && (
            <ItemizationForm
              transactionId={item.transaction_id}
              merchant={item.merchant}
              amount={item.amount}
              onSubmitted={() => { setExpandedId(null); load(); }}
              onCancel={() => setExpandedId(null)}
            />
          )}
        </div>
      ))}
    </div>
  );
}
